const validateString = (string) => {
  const result = /^[a-zA-Z0-9]+$/.test(string)
  return result
}
const validateStringWithSpace = (string) => {
  const result = /^[a-zA-Z0-9]+(\s\w+)*$/.test(string)
  return result
}
const validateNumber = (number) => {
  const result = /^[0-9]+(\.[0-9]{1,2})?$/.test(number)
  return result
}
const PH_COUNTRY_CODE = 175
const validatePhMobileNumber = (mobileNumber) =>
  !/^(0|[1-9][0-9]{9})$/i.test(mobileNumber)
const validateMobileNumberOnlyIfPh = ({ mobileNumber, countryCodeId }) => {
  let hasError = false
  const isPhilippines = PH_COUNTRY_CODE === countryCodeId
  const error = {}
  if (!mobileNumber) {
    error.mobileNumber = "Mobile Number is required"
    hasError = true
  } else if (isNaN(Number(mobileNumber))) {
    error.mobileNumber = "Mobile Number is not in a valid format"
    hasError = true
  } else if (isPhilippines && validatePhMobileNumber(mobileNumber)) {
    error.mobileNumber = "Mobile Number must only contain 10 digits."
    hasError = true
  }
  return { hasError, error }
}
const validateEmail = (email) => {
  const result = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(email)
  return result
}
export {
  validateString,
  validateStringWithSpace,
  validateNumber,
  validateMobileNumberOnlyIfPh,
  validateEmail,
}
